module.exports = __webpack_public_path__ + "static/media/Daniel Trucil Headshot.50451bec.jpeg";